module.exports = __webpack_public_path__ + "static/media/19ESCAP28.6232acd2.jpg";